import { Typography, Box } from "@mui/material";
import React from "react";
import { StyledGrid, StyledH3Heading } from "../style/StyledComponents";
import { useTheme } from "@emotion/react";

const PodcastIntroSection = () => {
  const theme = useTheme();

  const handleLinkClick = () => {
    window.open('https://castos.com/tools/find-podcast-rss-feed/', '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <StyledGrid container>
        <StyledGrid item xs={12}>
          <StyledH3Heading>
            Free Podcast Notes Maker
          </StyledH3Heading>
        </StyledGrid>
        <StyledGrid item xs={12}>
          <Typography
            variant="body1"
            component="p"
            align="center"
            sx={{
              fontFamily: "Roboto, sans-serif",
              maxWidth: "600px",
              color: theme.palette.primary.main,
            }}
          >
            Create timestamped annotation, and notes for your podcast with ease. Save, loop, unloop, and highlight important sections, allowing you to revisit them effortlessly. You could search your RSS Feed for your podcast on {" "}
            <Box
              component="span"
              onClick={handleLinkClick}
              sx={{
                color: theme.palette.secondary.main,
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: '0.5em 1em',
                margin: '-0.5em -1em',
                borderRadius: '4px',
                transition: 'background-color 0.3s',
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.1)',
                },
                display: 'inline-block',
              }}
            >
            castos.com
            </Box>. You could also search on google as "example podcast RSS Feed". Please check FAQ for more details on RSS Feed.
          </Typography>
        </StyledGrid>
      </StyledGrid>
    </>
  );
};

export default PodcastIntroSection;